import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	FormFeedback,
	FormGroup,
	ModalFooter,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
// import { addNewGuideDetail, updateGuideDetail } from '../../../../slices/guideDetail/thunk';
// import { setRequireCloseModal } from '../../../../slices/guideDetail/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getOriginTypeList, getResidueCategoryList, getResidueList, getResidueTypeList, getUnitMeasurementList } from '../../../helpers/residue/backend_helper';
import OSelect from '../../../Components/OElements/OSelect';
import { getPersonList } from '../../../helpers/establishment/backend_helper';
import { toSmartTitleCase } from '../../../utils/toSmartTitleCase';
// import { getGuideDetailCategoryList, getGuideDetailTypeList } from '../../../../helpers/guideDetail/backend_helper';
// import { getGuideDetailTypeList } from '../../../../helpers/guideDetail/backend_helper';

const ParticipantForm = ({
	dataParticipant,
	isEdit,
	handleToggleModal,
	isOpen,
	participantsList,
	handleParticipantsList
}) => {
	const dispatch = useDispatch();

	const [selectedPerson, setSelectedPerson] = useState(null);
	const handlePersonSelected = (optionSelected) => {
		setSelectedPerson(optionSelected);
	};

	const [externalCheck, setExternalCheck] = useState(dataParticipant.external || false);
	const [responsibleCheck, setResponsibleCheck] = useState(dataParticipant.responsible || false);

	const getParticipantIdentity = participant => (
		participant?.id ||
		participant?.person_id ||
		participant?.person?.id ||
		participant?.person?._id ||
		null
	);

	const getParticipantDisplayName = person => {
		if (!person) return '';
		if (person.name) return toSmartTitleCase(person.name);
		return toSmartTitleCase(`${person.first_name || ''} ${person.last_name || ''}`.trim());
	};

	const handlerExternalCheckboxChange = () => {
		setExternalCheck(!externalCheck);
	};

	const handlerResponsibleCheckboxChange = () => {
		setResponsibleCheck(!responsibleCheck);
	};

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			person_id: '',
			organization: ''
		},
		validationSchema: Yup.object({
			person_id: Yup.string().required('Campo requerido'),
			organization: Yup.string()
		}),
		onSubmit: values => {
			const selectedOrCurrentPerson = selectedPerson || dataParticipant?.person || null;
			const personId = values.person_id || selectedOrCurrentPerson?.id || selectedOrCurrentPerson?._id;
			const originalParticipantId = getParticipantIdentity(dataParticipant);

			if (!personId) {
				toast.error('Debe seleccionar un participante.', { autoClose: 3000 });
				return;
			}

			const normalizedPerson = selectedOrCurrentPerson
				? { ...selectedOrCurrentPerson, id: selectedOrCurrentPerson.id || selectedOrCurrentPerson._id }
				: {
					id: personId,
					_id: personId,
					first_name: '',
					last_name: '',
				};

			const newParticipant = {
				person_id: personId,
				person: normalizedPerson,
				external: externalCheck,
				responsible: responsibleCheck,
				organization: values.organization,
				...(dataParticipant?.id && {
					id: dataParticipant.id,
				}),
			};
			const isAdded = handlerItemParticipant(newParticipant, originalParticipantId);
			if (isAdded) {
				handleToggleModal(!isOpen);
			}
			if (isAdded) {
				validation.setFieldValue('person_id', '');
				validation.setFieldValue('organization', '');
			}
		},
	});

	function handlerItemParticipant(newParticipant, originalParticipantId = null) {
		let participantAdded = false;
		let isError = false;
		const participantFounded = participantsList.find(participant => (
			getParticipantIdentity(participant) === newParticipant.person.id
		));
		const responsibleParticipant = participantsList.find(participant => (
			participant.responsible === true &&
			getParticipantIdentity(participant) !== originalParticipantId
		));

		if (
			responsibleParticipant &&
			getParticipantIdentity(responsibleParticipant) != newParticipant.person.id &&
			newParticipant.responsible
		) {
			isError = true;
			toast.error(`Ya existe un responsable.`, { autoClose: 3000 });
		}

		if (participantFounded && !isEdit) {
			isError = true;
			toast.error(`Ya existe el participante "${newParticipant.person.first_name} ${newParticipant.person.last_name}".`, { autoClose: 3000 });
		}

		if (!participantFounded && !isEdit && !isError) {
			handleParticipantsList([...participantsList, newParticipant]);
			participantAdded = true;
			toast.success(
				`Participante ${newParticipant.person.first_name || ''} ${newParticipant.person.last_name || ''}`.trim() + ' agregado exitosamente.',
				{ autoClose: 3000 }
			);
		}

		if (
			participantFounded &&
			isEdit &&
			getParticipantIdentity(participantFounded) !== originalParticipantId
		) {
			isError = true;
			toast.error(`Ya existe el participante "${getParticipantDisplayName(newParticipant.person)}".`, { autoClose: 3000 });
		}

		if (isEdit && !isError) {
			const updatedResiduesCollectedList = participantsList.map(participant => {
				if (
					getParticipantIdentity(participant) == originalParticipantId
				) {
					return { ...participant, ...newParticipant }
				} else {
					return participant
				}
			});
			handleParticipantsList(updatedResiduesCollectedList);
			participantAdded = true;
			toast.success(`Participante "${getParticipantDisplayName(newParticipant.person)}" actualizado exitosamente.`, { autoClose: 3000 });
		}

		return participantAdded;
	}

	useEffect(() => {
		if (dataParticipant) {
			validation.setFieldValue('person_id', dataParticipant.person?.id || dataParticipant.person?._id || '');
			setResponsibleCheck(Boolean(dataParticipant.responsible));
			setExternalCheck(Boolean(dataParticipant.external));
			validation.setFieldValue('organization', dataParticipant.organization || '');
		}
	}, [dataParticipant])

	useEffect(() => {
		if (!externalCheck) {
			validation.setFieldValue('organization', '');
		}
	}, [externalCheck])

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={'1'}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={6}>
								<OSelect
									key={`person_id${dataParticipant.person?.id || ''}` || ''}
									label='Participante'
									id='person_id'
									name='person_id'
									value={validation.values.person_id || ''}
									handleLabelOptions={(item) => toSmartTitleCase(`${item.name || ''}`)}
									onSelect={handlePersonSelected}
									requestApi={() => getPersonList()}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col md={6}>
								<Label for='organization' className='form-label'>
									Organización
								</Label>
								<Input
									name='organization'
									id='organization'
									className='form-control'
									placeholder='Ingrese una organización'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.organization}
									invalid={
										validation.touched.organization &&
											validation.errors.organization
											? true : false
									}
									disabled={
										(
											externalCheck
												? false
												: true
										)
									}
								/>
								{
									validation.touched.organization &&
										validation.errors.organization ? (
										<FormFeedback type='invalid'>
											{validation.errors.organization}
										</FormFeedback>
									) : null
								}
							</Col>
							<Col lg={2}>
								<div className="form-check form-switch form-switch-right">
									<Label
										className="form-check-label text-muted"
										for="external"
									>
										{externalCheck ? 'Externo' : 'Interno'}
									</Label>
									<input
										type="checkbox"
										className="form-check-input"
										id="external"
										checked={externalCheck}
										onChange={handlerExternalCheckboxChange}
									/>
								</div>
							</Col>
							<Col lg={2}>
								<div className="form-check form-switch form-switch-right">
									<Label
										className="form-check-label text-muted"
										for="responsible"
									>
										Responsable
									</Label>
									<input
										type="checkbox"
										className="form-check-input"
										id="responsible"
										checked={responsibleCheck}
										onChange={handlerResponsibleCheckboxChange}
									/>
								</div>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<ModalFooter>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='button'
						className='btn btn-label btn-primary'
						onClick={() => {
							validation.handleSubmit();
						}}
					>
						<i className='ri-save-line label-icon'></i>
						Guardar
					</button>
				</div>
			</ModalFooter>
		</Form>
	);
};

export default ParticipantForm;
